import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["onClose", "beforeClose"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { noop } from '../utils';
import BaseImagePreview from './ImagePreview';
import { resolveContainer } from '../utils/dom/getContainer';
var ImagePreview = BaseImagePreview;
var defaultConfig = {
  loop: true,
  images: [],
  className: '',
  showIndex: true,
  closeable: false,
  closeIcon: 'clear',
  startPosition: 0,
  swipeDuration: 300,
  closeOnPopstate: true,
  closeIconPosition: 'top-right'
}; // 可返回用于销毁此弹窗的方法

ImagePreview.open = function (props) {
  var _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? noop : _props$onClose,
      beforeClose = props.beforeClose,
      restProps = _objectWithoutProperties(props, _excluded);

  var userContainer = resolveContainer(props.teleport);
  var container = document.createElement('div');
  userContainer.appendChild(container);
  var destroy = noop;

  var TempDialog = function TempDialog() {
    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        visible = _useState2[0],
        setVisible = _useState2[1];

    useEffect(function () {
      setVisible(true);
    }, []);

    destroy = function destroy(p) {
      setVisible(false);
      if (onClose) onClose(p);
    };

    var _afterClose = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(p) {
        var unmountResult;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return beforeClose === null || beforeClose === void 0 ? void 0 : beforeClose(0);

              case 2:
                _context.t0 = _context.sent;

                if (!(_context.t0 !== false)) {
                  _context.next = 8;
                  break;
                }

                destroy(p);
                unmountResult = ReactDOM.unmountComponentAtNode(container);

                if (unmountResult && container.parentNode) {
                  container.parentNode.removeChild(container);
                }

                return _context.abrupt("return", true);

              case 8:
                return _context.abrupt("return", false);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function _afterClose(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    return /*#__PURE__*/React.createElement(BaseImagePreview, _extends({}, defaultConfig, restProps, {
      visible: visible,
      teleport: function teleport() {
        return container;
      },
      onClose: destroy,
      beforeClose: _afterClose
    }));
  };

  ReactDOM.render( /*#__PURE__*/React.createElement(TempDialog, null), container);
  return destroy;
};

export default ImagePreview;